"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var each_1 = require("./each");
var is_array_like_1 = require("./is-array-like");
var filter = function (arr, func) {
    if (!is_array_like_1.default(arr)) {
        return arr;
    }
    var result = [];
    each_1.default(arr, function (value, index) {
        if (func(value, index)) {
            result.push(value);
        }
    });
    return result;
};
exports.default = filter;
//# sourceMappingURL=filter.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/filter.js
// module id = 398
// module chunks = 37